import { session } from '../../../Service/APIService';

const getClientSpecificTag = () => {
  const { clientName } = session.user();
  return clientName === 'KSEB' ? '_KSEB' : '';
};

const getImageDoublePointImage = (path, altText, orientation) => {
  const src = `${path}${
    orientation === 'horizontal' ? '_hz' : ''
  }${getClientSpecificTag()}.png`;
  const alt = `${altText}${orientation === 'horizontal' ? 'Hz' : ''}`;
  return {
    src,
    alt,
  };
};

const getDefaultData = () => ({ src: '', alt: '' });

const doublePointImageMapping = {
  breaker: {
    0: {
      path: 'Double_Point_Circuit_Breaker_Open_vt_raw_IEE75',
      alt: 'doublePointCircuitBreakerOpenRaw',
    },
    1: {
      path: 'Double_Point_Circuit_Breaker_Open_IEE75',
      alt: 'doublePointCircuitBreakerOpen',
    },
    2: {
      path: 'Double_Point_Circuit_Breaker_Closed_IEE75',
      alt: 'doublePointCircuitBreakerClosed',
    },
    3: {
      path: 'Double_Point_Circuit_Breaker_Ready_IEE75',
      alt: 'doublePointCircuitBreakerReady',
    },
  },
};

const renderDoublePointImage = (className, DICurrentStatus, orientation) => {
  const mappedClass = doublePointImageMapping[className];
  if (mappedClass) {
    const mappedStatus = mappedClass[DICurrentStatus];
    if (mappedStatus) {
      return getImageDoublePointImage(
        mappedStatus.path,
        mappedStatus.alt,
        orientation
      );
    } else {
      return getDefaultData();
    }
  } else {
    return getDefaultData();
  }
};

export { renderDoublePointImage };
